<div class="row">
  <div class="col-md-3">
      <div class="label form-label">{{attribute.name}} {{ attribute.required ? '*' : ''}}</div>
    <div class="description" *ngIf="attribute.description">{{attribute.description}}</div>
  </div>
  <div class="col-md-9">
      <mat-form-field class="full" appearance="outline" color="warn">
          <input matInput [type]="inputType" placeholder="{{attribute.name}}" [required]="attribute.required" [formControl]="oneControl" [min]="min" [max]="max" *ngIf="inputType != 'textarea'">
          <textarea matInput rows="5" placeholder="{{attribute.name}}" [required]="attribute.required" [formControl]="oneControl" *ngIf="inputType === 'textarea'"></textarea>
          <mat-error *ngIf="oneControl.invalid">Vui lòng nhập {{attribute.name}}</mat-error>
      </mat-form-field>

  </div>
</div>
